import { AlertTriangle, RefreshCw, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { cn } from "@/lib/utils";

export function AuthConnectionBanner() {
  const { authError, isRefreshPaused, retryConnection, signOut } = useAuth();

  if (!authError && !isRefreshPaused) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-destructive/10 border-b border-destructive/30 px-4 py-3">
      <div className="container mx-auto max-w-5xl flex items-center gap-4">
        <AlertTriangle className="h-5 w-5 text-destructive flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-destructive">
            {authError || "Authentication service is temporarily unavailable"}
          </p>
          <p className="text-xs text-muted-foreground">
            Your session may not stay active. Try retrying or signing out.
          </p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <Button
            size="sm"
            variant="outline"
            onClick={retryConnection}
          >
            <RefreshCw className="h-4 w-4 mr-2" />
            Retry
          </Button>
          <Button
            size="sm"
            variant="ghost"
            onClick={signOut}
          >
            <LogOut className="h-4 w-4 mr-2" />
            Sign Out
          </Button>
        </div>
      </div>
    </div>
  );
}
